import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { type TrafficRow, api } from "../lib/api";
import { TrafficForm, type TrafficFormValues, updateTraffic } from "./TrafficForm";

function toFormValues(t: TrafficRow): TrafficFormValues {
	const joinJson = (s: string | null): string => {
		if (!s) return "";
		try {
			const v = JSON.parse(s);
			return Array.isArray(v) ? (v as string[]).join(",") : "";
		} catch {
			return "";
		}
	};
	return {
		displayName: t.displayName,
		vertical: t.vertical,
		subverticals: joinJson(t.subverticals),
		geos: joinJson(t.geos),
		sources: joinJson(t.sources),
		monthlyVolume: String(t.monthlyVolume ?? 0),
		avgConversionRate: String(t.avgConversionRate ?? 0),
		fraudScore: String(t.fraudScore ?? 0),
	};
}

export function TrafficEdit() {
	const { id = "" } = useParams();
	const nav = useNavigate();
	const { data, isLoading, error } = useQuery<TrafficRow>({
		queryKey: ["traffic", id],
		queryFn: () => api.get(`/traffic/${id}`),
		enabled: !!id,
	});

	if (isLoading) return <div className="p-6">Loading…</div>;
	if (error) return <div className="p-6 text-red-700">Error: {(error as Error).message}</div>;
	if (!data) return <div className="p-6">Not found</div>;

	return (
		<div className="p-6">
			<h1 className="mb-4 text-xl font-semibold">Edit traffic profile</h1>
			<TrafficForm
				initial={toFormValues(data)}
				submitLabel="Save"
				onSubmit={async (v) => {
					await updateTraffic(id, v);
					nav(`/traffic/${id}`, { replace: true });
				}}
				onCancel={() => nav(`/traffic/${id}`)}
			/>
		</div>
	);
}
